import { Injectable } from '@angular/core';
import { PublicHttpService } from './public-http.service';

interface TenantRecord {
  tenantId: string;
  preferredTenantId: string;
  displayName?: string | null;
  isActive: boolean;
}

interface TenantConnection {
  items: TenantRecord[];
}

interface ListTenantsByAliasResponse {
  listTenantsByAlias: TenantConnection;
}

@Injectable({
  providedIn: 'root',
})
export class TenantDirectoryService {
  constructor(private readonly publicHttp: PublicHttpService) {}

  async resolveAlias(alias: string): Promise<TenantRecord | undefined> {
    if (!alias) {
      return undefined;
    }

    const query = `
      query ListTenantsByAlias($preferredTenantId: String!, $limit: Int) {
        listTenantsByAlias(preferredTenantId: $preferredTenantId, limit: $limit) {
          items {
            tenantId
            preferredTenantId
            displayName
            isActive
          }
        }
      }
    `;

    const response = await this.publicHttp.query<ListTenantsByAliasResponse>(query, {
      preferredTenantId: alias,
      limit: 1,
    });

    return response.listTenantsByAlias.items[0];
  }
}
